export const collectionQueryKeys = {
  all: ["collection"] as const,
  details: () => [...collectionQueryKeys.all, "details"] as const,
  detail: (collectionId: string | undefined) =>
    [...collectionQueryKeys.details(), collectionId] as const,
};
